import { commaSeparatedNumber } from '@/lib/math'

/**
 * Get the string of a count with label,
 * where the label gets pluralized based on the value of the count.
 * Count gets comma separated by default
 */
export const getCountWithLabel = (
  count: number,
  label: string,
  formatCount = true
) => {
  const pluralizedLabel = count === 1 ? label : `${label}s`
  const countDisplay = formatCount ? commaSeparatedNumber(count) : count
  return `${countDisplay} ${pluralizedLabel}`
}
